'use strict';

const BaseStore = require('fluxible/addons/BaseStore');

class TradeMessageStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);

        this._state = {
            messageVisible: false,
        };
    }

    onMessageToggle(isVisible) {
        this._state.messageVisible = isVisible;
        this.emitChange();
    }

    canShowMessage() {
        return this._state.messageVisible;
    }

    isLoaded() {
        return this._state.isLoaded;
    }
}

TradeMessageStore.storeName = 'TradeMessageStore';

TradeMessageStore.handlers = {
    'message:trade:toggle': 'onMessageToggle',
};

module.exports = TradeMessageStore;



// WEBPACK FOOTER //
// ./assets/js/global/stores/TradeMessageStore.es.js